import React, { useEffect, useState } from 'react';
import DocsInputNew from '../../../components/Inputs/DocsInput/DocsInputNew';
import HookForm from '../../../components/HookForm/HookForm';
import {
  DEAL_STATUS_NOTARIAL_DOCUMENTS_UPLOADED,
  DEAL_STATUS_WAIRING_REGISTRATION,
  DEAL_STATUS_WAITING_CLIENT_BANK_DOSCAR_AGREEMENT,
  DEAL_STATUS_WAITING_FOR_NOTARIAL_DOCUMENTS,
  DEAL_STATUS_WAITING_FOR_PAYMENT,
  DEAL_STATUS_WAITING_FOR_PLEDGE_DOCUMENTS,
  DEAL_STATUS_WAITING_FOR_REGISTRATION_DOCUMENTS,
  DEAL_STATUS_WAITING_SIGNING_APPLICATION_FOR_ADDITIONAL_SERVICES,
  DEAL_STEPS,
  DOCUMENT_TYPES_APPLICATION_FOR_ADDITIONAL_SERVICES,
  DOCUMENT_TYPES_APPLICATION_PREMIUM_AND_ADDITIONAL_EQUIPMENT_LOAN,
  DOCUMENT_TYPES_CLIENT_BANK_DOSCAR_AGREEMENT,
  DOCUMENT_TYPES_GRNZ,
  DOCUMENT_TYPES_GUARANTEE_LETTER,
  DOCUMENT_TYPES_INVOICE,
  DOCUMENT_TYPES_NO_TAX_DEBT,
  DOCUMENT_TYPES_PAYMENT_ORDER,
  DOCUMENT_TYPES_PLEDGE_AGREEMENT,
  DOCUMENT_TYPES_PLEDGE_APPLICATION,
  DOCUMENT_TYPES_POWER_OF_ATTORNEY,
  DOCUMENT_TYPES_SPOUSE_CONSENT,
  DOCUMENT_TYPES_TECH_PASSPORT,
  DOCUMENT_TYPES_UDV,
  PAYMENT_STATUS_PAID,
} from '../../../constants';
import SelectDealPaymentStatuses from '../../../components/Selects/selectDealPaymentStatuses';
import editDeal from '../../../api/deals/editDeal';
import setStep from '../../../api/deals/setStep';
import alert from '../../../helpers/alert';
import uploadDocumentToDeal from '../../../api/deals/uploadDocumentToDeal';
import Button from '../../../components/Button/Button';
import { socket } from '../../../App';
import generateAllowedDocumentsJson from '../../../utils/generateAllowedDocumentsJson';
import DownloadFileLink from '../../../components/DownloadFileLink/DownloadFileLink';
import HalykNotarialDocuments from './HalykFlow/HalykNotarialDocuments';
import sendMarriedDoc from '../../../api/creditPlatform/sendMarriedDoc';
import isFileSizeSmallerThan from '../../../utils/validateFileSize';
import StepControlButtons from './CommonBankSteps/StepControlButtons';
import { stepAfterNotarialDocuments } from './bankFirstStep';

const DealCreateCreditDocuments = ({ documents, backHandler, deal, update, chosenBankAppealId, chosenBankId }) => {
  const [loading, setLoading] = useState(false);
  const [agreementClientBankDoscar, setAgreementClientBankDoscar] = useState(null);
  const [applicationAdditionalServices, setApplicationAdditionalServices] = useState(null);

  const onAgreementFormSubmit = () => {
    if (!agreementClientBankDoscar) {
      return alert.error('ÐÐµÐ¾Ð±ÑÐ¾Ð´Ð¸Ð¼Ð¾ Ð·Ð°Ð³ÑÑÐ·Ð¸ÑÑ ÑÐ¾Ð³Ð»Ð°ÑÐµÐ½Ð¸Ðµ');
    }

    setLoading(true);

    uploadDocumentToDeal({
      dealId: deal?.id,
      fileTypeId: DOCUMENT_TYPES_CLIENT_BANK_DOSCAR_AGREEMENT,
      file: agreementClientBankDoscar,
      signed: true,
    })
      .then(() => {
        editDeal({
          id: deal?.id,
          statusId: DEAL_STATUS_WAITING_FOR_PAYMENT,
          ...generateAllowedDocumentsJson([
            DOCUMENT_TYPES_CLIENT_BANK_DOSCAR_AGREEMENT,
            DOCUMENT_TYPES_INVOICE,
            DOCUMENT_TYPES_GUARANTEE_LETTER,
          ]),
        })
          .then(() => {
            update && update();
          })
          .catch(() => {
            alert.error('ÐÑÐ¸Ð±ÐºÐ° Ð¾Ð±Ð½Ð¾Ð²Ð»ÐµÐ½Ð¸Ñ ÑÑÐ°ÑÑÑÐ° ÑÐ´ÐµÐ»ÐºÐ¸');
          })
          .finally(() => {
            setLoading(false);
          });
      })
      .catch(() => {
        alert.error('ÐÑÐ¸Ð±ÐºÐ° Ð·Ð°Ð³ÑÑÐ·ÐºÐ¸ ÑÐ¾Ð³Ð»Ð°ÑÐµÐ½Ð¸Ñ');
        setLoading(false);
      });
  };

  const onPaymentFormSubmit = (values) => {
    setLoading(true);

    editDeal({
      id: deal?.id,
      statusPaymentId: values?.status?.value,
      statusId:
        values?.status?.value === PAYMENT_STATUS_PAID
          ? DEAL_STATUS_WAITING_SIGNING_APPLICATION_FOR_ADDITIONAL_SERVICES
          : deal?.status?.id,
      ...generateAllowedDocumentsJson([
        DOCUMENT_TYPES_CLIENT_BANK_DOSCAR_AGREEMENT,
        DOCUMENT_TYPES_INVOICE,
        DOCUMENT_TYPES_APPLICATION_FOR_ADDITIONAL_SERVICES,
        DOCUMENT_TYPES_GUARANTEE_LETTER,
      ]),
    })
      .then(() => {
        alert.success('Ð¡ÑÐ°ÑÑÑ Ð¾Ð¿Ð»Ð°ÑÑ ÑÑÐ¿ÐµÑÐ½Ð¾ Ð¾Ð±Ð½Ð¾Ð²Ð»ÐµÐ½');
        update && update();
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const onApplicationFormSubmit = () => {
    setLoading(true);

    if (!applicationAdditionalServices) {
      return alert.error('ÐÐµÐ¾Ð±ÑÐ¾Ð´Ð¸Ð¼Ð¾ Ð·Ð°Ð³ÑÑÐ·Ð¸ÑÑ ÑÐ¾Ð³Ð»Ð°ÑÐµÐ½Ð¸Ðµ');
    }

    uploadDocumentToDeal({
      dealId: deal?.id,
      fileTypeId: DOCUMENT_TYPES_APPLICATION_FOR_ADDITIONAL_SERVICES,
      file: applicationAdditionalServices,
    })
      .then(() => {
        editDeal({
          id: deal?.id,
          statusId: DEAL_STATUS_WAITING_FOR_NOTARIAL_DOCUMENTS,
          ...generateAllowedDocumentsJson([
            DOCUMENT_TYPES_CLIENT_BANK_DOSCAR_AGREEMENT,
            DOCUMENT_TYPES_INVOICE,
            DOCUMENT_TYPES_APPLICATION_FOR_ADDITIONAL_SERVICES,
            DOCUMENT_TYPES_GUARANTEE_LETTER,
          ]),
        })
          .then(() => {
            update && update();
          })
          .catch(() => {
            alert.error('ÐÑÐ¸Ð±ÐºÐ° Ð¾Ð±Ð½Ð¾Ð²Ð»ÐµÐ½Ð¸Ñ ÑÑÐ°ÑÑÑÐ° ÑÐ´ÐµÐ»ÐºÐ¸');
          })
          .finally(() => {
            setLoading(false);
          });
      })
      .catch(() => {
        alert.error('ÐÑÐ¸Ð±ÐºÐ° Ð·Ð°Ð³ÑÑÐ·ÐºÐ¸ ÑÐ¾Ð³Ð»Ð°ÑÐµÐ½Ð¸Ñ');
        setLoading(false);
      });
  };

  const onCarDocumentsFormSubmit = async (files) => {
    if (!files['Ð¢ÐµÑÐ¿Ð°ÑÐ¿Ð¾ÑÑ'] || !files['ÐÐ ÐÐ']) {
      return alert.error('ÐÐµÐ¾Ð±ÑÐ¾Ð´Ð¸Ð¼Ð¾ Ð·Ð°Ð³ÑÑÐ·Ð¸ÑÑ Ð²ÑÐµ Ð´Ð¾ÐºÑÐ¼ÐµÐ½ÑÑ');
    }

    try {
      await uploadDocumentToDeal({
        dealId: deal?.id,
        fileTypeId: DOCUMENT_TYPES_GRNZ,
        file: files['ÐÐ ÐÐ'],
      });

      await uploadDocumentToDeal({
        dealId: deal?.id,
        fileTypeId: DOCUMENT_TYPES_TECH_PASSPORT,
        file: files['Ð¢ÐµÑÐ¿Ð°ÑÐ¿Ð¾ÑÑ'],
      });

      editDeal({
        id: deal?.id,
        statusId: DEAL_STATUS_WAITING_FOR_NOTARIAL_DOCUMENTS,
      })
        .then(() => {
          update && update();
        })
        .catch(() => {
          alert.error('ÐÑÐ¸Ð±ÐºÐ° Ð¾Ð±Ð½Ð¾Ð²Ð»ÐµÐ½Ð¸Ñ ÑÑÐ°ÑÑÑÐ° ÑÐ´ÐµÐ»ÐºÐ¸');
        })
        .finally(() => {
          setLoading(false);
        });
    } catch (error) {
      alert.error('ÐÑÐ¸Ð±ÐºÐ° Ð·Ð°Ð³ÑÑÐ·ÐºÐ¸ Ð´Ð¾ÐºÑÐ¼ÐµÐ½ÑÐ¾Ð²');
      setLoading(false);
    }
  };

  const notarialDocumentsUploadedFormSubmit = () => {
    // Ð£ Ð±Ð°Ð½ÐºÐ°, ÐºÐ¾ÑÐ¾ÑÑÐ¹ Ð·Ð°Ð»Ð¾Ð³Ð¾Ð²ÑÐµ Ð´Ð¾ÐºÑÐ¼ÐµÐ½ÑÑ Ð½Ðµ ÑÐ¾Ð±Ð¸ÑÐ°ÐµÑ (Solva), ÑÐºÑÐ°Ð½ Ñ
    // Ð´Ð¾Ð³Ð¾Ð²Ð¾ÑÐ¾Ð¼ Ð·Ð°Ð»Ð¾Ð³Ð° Ð¿ÑÐ¾Ð¿ÑÑÐºÐ°ÐµÐ¼ Ð¸ ÑÐ²Ð¾Ð´Ð¸Ð¼ ÑÐ´ÐµÐ»ÐºÑ ÑÑÐ°Ð·Ñ Ð½Ð° ÑÐµÐ³Ð¸ÑÑÑÐ°ÑÐ¸Ñ Ð¢Ð¡.
    const registrationStep = stepAfterNotarialDocuments(chosenBankId);

    editDeal({
      id: deal?.id,
      statusId: registrationStep ? DEAL_STATUS_WAIRING_REGISTRATION : DEAL_STATUS_WAITING_FOR_PLEDGE_DOCUMENTS,
      ...generateAllowedDocumentsJson([
        DOCUMENT_TYPES_CLIENT_BANK_DOSCAR_AGREEMENT,
        DOCUMENT_TYPES_INVOICE,
        DOCUMENT_TYPES_APPLICATION_FOR_ADDITIONAL_SERVICES,
        DOCUMENT_TYPES_POWER_OF_ATTORNEY,
        DOCUMENT_TYPES_SPOUSE_CONSENT,
        DOCUMENT_TYPES_GRNZ,
        DOCUMENT_TYPES_TECH_PASSPORT,
        DOCUMENT_TYPES_GUARANTEE_LETTER,
      ]),
    })
      .then(async () => {
        if (registrationStep) {
          await setStep({ dealId: deal?.id, step: registrationStep });
        }
        update && update();
      })
      .catch(() => {
        alert.error('ÐÑÐ¸Ð±ÐºÐ° Ð¾Ð±Ð½Ð¾Ð²Ð»ÐµÐ½Ð¸Ñ ÑÑÐ°ÑÑÑÐ° ÑÐ´ÐµÐ»ÐºÐ¸');
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const onRegistarationDocumentsFormSubmit = async (files) => {
    if (
      !files['ÐÐ¾Ð³Ð¾Ð²Ð¾Ñ Ð·Ð°Ð»Ð¾Ð³Ð°'] ||
      !files['ÐÐ°ÑÐ²Ð»ÐµÐ½Ð¸Ðµ Ð¾ Ð¿Ð¾ÑÑÐ°Ð½Ð¾Ð²ÐºÐµ Ð¢Ð¡ Ð² Ð·Ð°Ð»Ð¾Ð³'] ||
      !files['Ð£Ð´Ð¾ÑÑÐ¾Ð²ÐµÑÐµÐ½Ð¸Ðµ Ð»Ð¸ÑÐ½Ð¾ÑÑÐ¸'] ||
      !files['Ð¡Ð¿ÑÐ°Ð²ÐºÐ° Ð¾Ð± Ð¾ÑÑÑÑÑÑÐ²Ð¸Ð¸ Ð½Ð°Ð»Ð¾Ð³Ð¾Ð²Ð¾Ð¹ Ð·Ð°Ð´Ð¾Ð»Ð¶ÐµÐ½Ð½Ð¾ÑÑÐ¸'] ||
      !files['ÐÐ°ÑÐ²Ð»ÐµÐ½Ð¸Ðµ Ð¾ Ð²ÐºÐ»ÑÑÐµÐ½Ð¸Ð¸']
    ) {
      return alert.error('ÐÐµÐ¾Ð±ÑÐ¾Ð´Ð¸Ð¼Ð¾ Ð·Ð°Ð³ÑÑÐ·Ð¸ÑÑ Ð²ÑÐµ Ð´Ð¾ÐºÑÐ¼ÐµÐ½ÑÑ');
    }

    setLoading(true);
    try {
      await uploadDocumentToDeal({
        dealId: deal?.id,
        fileTypeId: DOCUMENT_TYPES_PLEDGE_AGREEMENT,
        file: files['ÐÐ¾Ð³Ð¾Ð²Ð¾Ñ Ð·Ð°Ð»Ð¾Ð³Ð°'],
      });

      await uploadDocumentToDeal({
        dealId: deal?.id,
        fileTypeId: DOCUMENT_TYPES_PLEDGE_APPLICATION,
        file: files['ÐÐ°ÑÐ²Ð»ÐµÐ½Ð¸Ðµ Ð¾ Ð¿Ð¾ÑÑÐ°Ð½Ð¾Ð²ÐºÐµ Ð¢Ð¡ Ð² Ð·Ð°Ð»Ð¾Ð³'],
      });

      await uploadDocumentToDeal({
        dealId: deal?.id,
        fileTypeId: DOCUMENT_TYPES_UDV,
        file: files['Ð£Ð´Ð¾ÑÑÐ¾Ð²ÐµÑÐµÐ½Ð¸Ðµ Ð»Ð¸ÑÐ½Ð¾ÑÑÐ¸'],
      });

      await uploadDocumentToDeal({
        dealId: deal?.id,
        fileTypeId: DOCUMENT_TYPES_NO_TAX_DEBT,
        file: files['Ð¡Ð¿ÑÐ°Ð²ÐºÐ° Ð¾Ð± Ð¾ÑÑÑÑÑÑÐ²Ð¸Ð¸ Ð½Ð°Ð»Ð¾Ð³Ð¾Ð²Ð¾Ð¹ Ð·Ð°Ð´Ð¾Ð»Ð¶ÐµÐ½Ð½Ð¾ÑÑÐ¸'],
      });

      await uploadDocumentToDeal({
        dealId: deal?.id,
        fileTypeId: DOCUMENT_TYPES_APPLICATION_PREMIUM_AND_ADDITIONAL_EQUIPMENT_LOAN,
        file: files['ÐÐ°ÑÐ²Ð»ÐµÐ½Ð¸Ðµ Ð¾ Ð²ÐºÐ»ÑÑÐµÐ½Ð¸Ð¸'],
      });

      editDeal({
        id: deal?.id,
        statusId: DEAL_STATUS_WAITING_FOR_REGISTRATION_DOCUMENTS,
        ...generateAllowedDocumentsJson([
          DOCUMENT_TYPES_CLIENT_BANK_DOSCAR_AGREEMENT,
          DOCUMENT_TYPES_INVOICE,
          DOCUMENT_TYPES_APPLICATION_FOR_ADDITIONAL_SERVICES,
          DOCUMENT_TYPES_POWER_OF_ATTORNEY,
          DOCUMENT_TYPES_SPOUSE_CONSENT,
          DOCUMENT_TYPES_GRNZ,
          DOCUMENT_TYPES_TECH_PASSPORT,
          DOCUMENT_TYPES_PLEDGE_AGREEMENT,
          DOCUMENT_TYPES_PLEDGE_APPLICATION,
          DOCUMENT_TYPES_UDV,
          DOCUMENT_TYPES_NO_TAX_DEBT,
          DOCUMENT_TYPES_APPLICATION_PREMIUM_AND_ADDITIONAL_EQUIPMENT_LOAN,
          DOCUMENT_TYPES_GUARANTEE_LETTER,
        ]),
      })
        .then(() => {
          setStep({
            dealId: deal?.id,
            step: 7,
          }).then(() => {
            update && update();
          });
        })
        .catch(() => {
          alert.error('ÐÑÐ¸Ð±ÐºÐ° Ð¾Ð±Ð½Ð¾Ð²Ð»ÐµÐ½Ð¸Ñ ÑÑÐ°ÑÑÑÐ° ÑÐ´ÐµÐ»ÐºÐ¸');
        })
        .finally(() => {
          setLoading(false);
        });
    } catch (error) {
      alert.error('ÐÑÐ¸Ð±ÐºÐ° Ð·Ð°Ð³ÑÑÐ·ÐºÐ¸ Ð´Ð¾ÐºÑÐ¼ÐµÐ½ÑÐ¾Ð²');
      setLoading(false);
    }
  };

  const skipStep = () => {
    setLoading(true);

    setStep({
      dealId: deal?.id,
      step: 7,
      ...generateAllowedDocumentsJson([
        DOCUMENT_TYPES_CLIENT_BANK_DOSCAR_AGREEMENT,
        DOCUMENT_TYPES_INVOICE,
        DOCUMENT_TYPES_APPLICATION_FOR_ADDITIONAL_SERVICES,
        DOCUMENT_TYPES_POWER_OF_ATTORNEY,
        DOCUMENT_TYPES_SPOUSE_CONSENT,
        DOCUMENT_TYPES_GRNZ,
        DOCUMENT_TYPES_TECH_PASSPORT,
        DOCUMENT_TYPES_PLEDGE_AGREEMENT,
        DOCUMENT_TYPES_PLEDGE_APPLICATION,
        DOCUMENT_TYPES_UDV,
        DOCUMENT_TYPES_NO_TAX_DEBT,
        DOCUMENT_TYPES_APPLICATION_PREMIUM_AND_ADDITIONAL_EQUIPMENT_LOAN,
        DOCUMENT_TYPES_GUARANTEE_LETTER,
      ]),
    })
      .then(() => {
        update && update();
      })
      .catch(() => {
        alert.error('ÐÑÐ¸Ð±ÐºÐ° Ð¾Ð±Ð½Ð¾Ð²Ð»ÐµÐ½Ð¸Ñ ÑÑÐ°ÑÑÑÐ° ÑÐ´ÐµÐ»ÐºÐ¸');
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    const listenerName = 'listenToChangeDealStatus' + deal?.id;
    socket.on(listenerName, (data) => {
      update && update();
    });
    return () => {
      socket.off(listenerName);
    };
  }, [deal, update]);

  const onNotarialDocumentsSubmit = async (values) => {
    setLoading(true);

    if (!values['ÑÐ¾Ð³Ð»Ð°ÑÐ¸Ðµ']) {
      alert.error('ÐÐµÐ¾Ð±ÑÐ¾Ð´Ð¸Ð¼Ð¾ Ð·Ð°Ð³ÑÑÐ·Ð¸ÑÑ ÑÐ¾Ð³Ð»Ð°ÑÐ¸Ðµ ÑÑÐ¿ÑÑÐ³Ð° (ÑÑÐ¿ÑÑÐ³Ð¸) Ð½Ð° Ð²Ð½ÐµÑÑÐ´ÐµÐ±Ð½ÑÑ ÑÐµÐ°Ð»Ð¸Ð·Ð°ÑÐ¸Ñ Ð°Ð²ÑÐ¾');
      setLoading(false);
      return;
    }

    if (!isFileSizeSmallerThan(values['ÑÐ¾Ð³Ð»Ð°ÑÐ¸Ðµ'], 5)) {
      alert.error('Ð Ð°Ð·Ð¼ÐµÑ ÑÐ°Ð¹Ð»Ð° ÑÐ¾Ð³Ð»Ð°ÑÐ¸Ñ ÑÑÐ¿ÑÑÐ³Ð° (ÑÑÐ¿ÑÑÐ³Ð¸) Ð½Ðµ Ð´Ð¾Ð»Ð¶ÐµÐ½ Ð¿ÑÐµÐ²ÑÑÐ°ÑÑ 5 ÐÐ');
      setLoading(false);
      return;
    }

    await uploadDocumentToDeal({
      dealId: deal?.id,
      fileTypeId: DOCUMENT_TYPES_SPOUSE_CONSENT,
      file: values['ÑÐ¾Ð³Ð»Ð°ÑÐ¸Ðµ'],
    });
    if (values['Ð´Ð¾Ð²ÐµÑÐµÐ½Ð½Ð¾ÑÑÑ']) {
      await uploadDocumentToDeal({
        dealId: deal?.id,
        fileTypeId: DOCUMENT_TYPES_POWER_OF_ATTORNEY,
        file: values['Ð´Ð¾Ð²ÐµÑÐµÐ½Ð½Ð¾ÑÑÑ'],
      });
    }

    sendMarriedDoc({ appealId: chosenBankAppealId })
      .then(() => {
        editDeal({
          id: deal?.id,
          dealId: deal?.id,
          statusId: DEAL_STATUS_NOTARIAL_DOCUMENTS_UPLOADED,
          power_of_attorney_number: values?.powerOfAttorneyNumber
            ? values?.powerOfAttorneyNumber
            : deal?.power_of_attorney_number,
          ...generateAllowedDocumentsJson([
            DOCUMENT_TYPES_CLIENT_BANK_DOSCAR_AGREEMENT,
            DOCUMENT_TYPES_INVOICE,
            DOCUMENT_TYPES_APPLICATION_FOR_ADDITIONAL_SERVICES,
            DOCUMENT_TYPES_POWER_OF_ATTORNEY,
            DOCUMENT_TYPES_SPOUSE_CONSENT,
            DOCUMENT_TYPES_GUARANTEE_LETTER,
          ]),
        })
          .then(() => {
            update();
          })
          .finally(() => {
            setLoading(false);
          });
      })
      .catch(() => {
        alert.error('ÐÐµ ÑÐ´Ð°Ð»Ð¾ÑÑ Ð¾ÑÐ¿ÑÐ°Ð²Ð¸ÑÑ ÑÐ¾Ð³Ð»Ð°ÑÐ¸Ðµ ÑÑÐ¿ÑÑÐ³Ð° (ÑÑÐ¿ÑÑÐ³Ð¸) Ð½Ð° Ð²Ð½ÐµÑÑÐ´ÐµÐ±Ð½ÑÑ ÑÐµÐ°Ð»Ð¸Ð·Ð°ÑÐ¸Ñ Ð°Ð²ÑÐ¾');
        setLoading(false);
      });
  };

  if (deal?.status?.id === DEAL_STATUS_WAITING_CLIENT_BANK_DOSCAR_AGREEMENT) {
    return (
      <div>
        <StepControlButtons
          dealId={deal?.id}
          prevStep={DEAL_STEPS.SELECT_BANKS}
          update={update}
          setLoading={setLoading}
        />
        <HookForm
          title={'ÐÐ¾ÐºÑÐ¼ÐµÐ½ÑÑ'}
          grid={{ display: 'grid', gap: 20 }}
          action={'Ð¡Ð¾ÑÑÐ°Ð½Ð¸ÑÑ Ð¸ Ð¿ÑÐ¾Ð´Ð¾Ð»Ð¶Ð¸ÑÑ'}
          inputs={[]}
          onSubmit={onAgreementFormSubmit}
          loading={loading}
          customData={() => (
            <div
              style={{
                display: 'grid',
                gap: 20,
              }}
            >
              <DocsInputNew
                text="Ð¡Ð¾Ð³Ð»Ð°ÑÐµÐ½Ð¸Ðµ Ð¼ÐµÐ¶Ð´Ñ ÐÐ»Ð¸ÐµÐ½ÑÐ¾Ð¼, ÐÐ°Ð½ÐºÐ¾Ð¼ Ð¸ Doscar"
                label="ÐÐ°Ð³ÑÑÐ·Ð¸ÑÑ Ð´Ð¾ÐºÑÐ¼ÐµÐ½Ñ"
                id="Ð¡Ð¾Ð³Ð»Ð°ÑÐµÐ½Ð¸Ðµ Ð¼ÐµÐ¶Ð´Ñ ÐÐ»Ð¸ÐµÐ½ÑÐ¾Ð¼, ÐÐ°Ð½ÐºÐ¾Ð¼ Ð¸ Doscar"
                value={agreementClientBankDoscar}
                onChange={setAgreementClientBankDoscar}
              />
            </div>
          )}
          customDataTop={() => (
            <div style={{ marginBottom: 40 }}>
              {documents
                ?.filter((item) => item?.typeId === DOCUMENT_TYPES_CLIENT_BANK_DOSCAR_AGREEMENT)
                .map((document) => (
                  <DownloadFileLink document={document} />
                ))}
            </div>
          )}
          backHandler={backHandler}
        />
      </div>
    );
  }

  if (deal?.status?.id === DEAL_STATUS_WAITING_FOR_PAYMENT) {
    return (
      <div>
        <HookForm
          title={'ÐÐ¾ÐºÑÐ¼ÐµÐ½ÑÑ'}
          grid={{ display: 'grid', gap: 20 }}
          action={'Ð¡Ð¾ÑÑÐ°Ð½Ð¸ÑÑ Ð¸ Ð¿ÑÐ¾Ð´Ð¾Ð»Ð¶Ð¸ÑÑ'}
          inputs={[
            {
              name: 'status',
              component: SelectDealPaymentStatuses,
            },
          ]}
          customDataTop={() => (
            <div style={{ marginBottom: 40 }}>
              {documents
                ?.filter((item) => item?.typeId === DOCUMENT_TYPES_INVOICE)
                .map((document) => (
                  <DownloadFileLink document={document} />
                ))}
            </div>
          )}
          onSubmit={onPaymentFormSubmit}
          loading={loading}
          backHandler={backHandler}
        />
      </div>
    );
  }

  if (deal?.status?.id === DEAL_STATUS_WAITING_SIGNING_APPLICATION_FOR_ADDITIONAL_SERVICES) {
    return (
      <div>
        <HookForm
          title={'ÐÐ¾ÐºÑÐ¼ÐµÐ½ÑÑ'}
          grid={{ display: 'grid', gap: 20 }}
          action={'Ð¡Ð¾ÑÑÐ°Ð½Ð¸ÑÑ Ð¸ Ð¿ÑÐ¾Ð´Ð¾Ð»Ð¶Ð¸ÑÑ'}
          inputs={[]}
          onSubmit={onApplicationFormSubmit}
          loading={loading}
          customData={() => (
            <div
              style={{
                display: 'grid',
                gap: 20,
              }}
            >
              <DocsInputNew
                text="ÐÐ°ÑÐ²Ð»ÐµÐ½Ð¸Ðµ Ð¿Ð¾ Ð´Ð¾Ð¿. ÑÑÐ»ÑÐ³Ð°Ð¼ Ð±Ð°Ð½ÐºÐ°"
                label="ÐÐ°Ð³ÑÑÐ·Ð¸ÑÑ Ð´Ð¾ÐºÑÐ¼ÐµÐ½Ñ"
                id="ÐÐ°ÑÐ²Ð»ÐµÐ½Ð¸Ðµ Ð¿Ð¾ Ð´Ð¾Ð¿. ÑÑÐ»ÑÐ³Ð°Ð¼ Ð±Ð°Ð½ÐºÐ°"
                value={applicationAdditionalServices}
                onChange={setApplicationAdditionalServices}
              />
            </div>
          )}
          customDataTop={() => (
            <div style={{ marginBottom: 40 }}>
              {documents
                ?.filter((item) => item?.typeId === DOCUMENT_TYPES_APPLICATION_FOR_ADDITIONAL_SERVICES)
                .map((document) => (
                  <DownloadFileLink document={document} />
                ))}
            </div>
          )}
          backHandler={backHandler}
        />
      </div>
    );
  }

  if (deal?.status?.id === DEAL_STATUS_WAIRING_REGISTRATION) {
    return (
      <div>
        <HookForm
          title={'ÐÐ¾ÐºÑÐ¼ÐµÐ½ÑÑ'}
          grid={{ display: 'grid', gap: 20 }}
          action={'Ð¡Ð¾ÑÑÐ°Ð½Ð¸ÑÑ Ð¸ Ð¿ÑÐ¾Ð´Ð¾Ð»Ð¶Ð¸ÑÑ'}
          inputs={[
            {
              text: 'ÐÐ ÐÐ',
              label: 'ÐÐ°Ð³ÑÑÐ·Ð¸ÑÑ Ð´Ð¾ÐºÑÐ¼ÐµÐ½Ñ',
              name: 'ÐÐ ÐÐ',
              id: 'ÐÐ ÐÐ',
              component: DocsInputNew,
            },
            {
              text: 'Ð¢ÐµÑÐ¿Ð°ÑÐ¿Ð¾ÑÑ',
              label: 'ÐÐ°Ð³ÑÑÐ·Ð¸ÑÑ Ð´Ð¾ÐºÑÐ¼ÐµÐ½Ñ',
              name: 'Ð¢ÐµÑÐ¿Ð°ÑÐ¿Ð¾ÑÑ',
              id: 'Ð¢ÐµÑÐ¿Ð°ÑÐ¿Ð¾ÑÑ',
              component: DocsInputNew,
            },
          ]}
          onSubmit={onCarDocumentsFormSubmit}
          loading={loading}
          backHandler={backHandler}
        />
      </div>
    );
  }

  if (deal?.status?.id === DEAL_STATUS_WAITING_FOR_NOTARIAL_DOCUMENTS) {
    return <HalykNotarialDocuments documents={documents} loading={loading} onSubmit={onNotarialDocumentsSubmit} />;
  }

  if (deal?.status?.id === DEAL_STATUS_NOTARIAL_DOCUMENTS_UPLOADED) {
    return (
      <HookForm
        title={'ÐÐ¾ÐºÑÐ¼ÐµÐ½ÑÑ'}
        grid={{ display: 'grid', gap: 20 }}
        action={'ÐÑÐ¾Ð´Ð¾Ð»Ð¶Ð¸ÑÑ'}
        inputs={[]}
        onSubmit={notarialDocumentsUploadedFormSubmit}
        loading={loading}
        customData={() => (
          <div>
            <p
              style={{
                fontWeight: 700,
                fontSize: '20px',
                lineHeight: '20px',
                color: 'rgb(73, 65, 54)',
                marginBottom: '20px',
              }}
            >
              Ð¡ÑÐ°ÑÑÑ
            </p>
            <Button
              text={'ÐÐÐ¢ÐÐ ÐÐÐÐ¬ÐÐ«Ð ÐÐÐÐ£ÐÐÐÐ¢Ð« ÐÐÐÐ Ð£ÐÐÐÐ«'}
              style={{ color: 'rgb(73, 65, 54)', border: '1px solid rgb(73, 65, 54)' }}
            />
          </div>
        )}
        backHandler={backHandler}
      />
    );
  }

  if (deal?.status?.id === DEAL_STATUS_WAITING_FOR_PLEDGE_DOCUMENTS) {
    return (
      <div>
        <HookForm
          title={'ÐÐ¾ÐºÑÐ¼ÐµÐ½ÑÑ'}
          grid={{ display: 'grid', gap: 20 }}
          action={'Ð¡Ð¾ÑÑÐ°Ð½Ð¸ÑÑ Ð¸ Ð¿ÑÐ¾Ð´Ð¾Ð»Ð¶Ð¸ÑÑ'}
          inputs={[
            {
              text: 'ÐÐ¾Ð³Ð¾Ð²Ð¾Ñ Ð·Ð°Ð»Ð¾Ð³Ð°',
              label: 'ÐÐ°Ð³ÑÑÐ·Ð¸ÑÑ Ð´Ð¾ÐºÑÐ¼ÐµÐ½Ñ',
              name: 'ÐÐ¾Ð³Ð¾Ð²Ð¾Ñ Ð·Ð°Ð»Ð¾Ð³Ð°',
              id: 'ÐÐ¾Ð³Ð¾Ð²Ð¾Ñ Ð·Ð°Ð»Ð¾Ð³Ð°',
              component: DocsInputNew,
              required: true,
            },
            {
              text: 'ÐÐ°ÑÐ²Ð»ÐµÐ½Ð¸Ðµ Ð¾ Ð¿Ð¾ÑÑÐ°Ð½Ð¾Ð²ÐºÐµ Ð¢Ð¡ Ð² Ð·Ð°Ð»Ð¾Ð³',
              label: 'ÐÐ°Ð³ÑÑÐ·Ð¸ÑÑ Ð´Ð¾ÐºÑÐ¼ÐµÐ½Ñ',
              name: 'ÐÐ°ÑÐ²Ð»ÐµÐ½Ð¸Ðµ Ð¾ Ð¿Ð¾ÑÑÐ°Ð½Ð¾Ð²ÐºÐµ Ð¢Ð¡ Ð² Ð·Ð°Ð»Ð¾Ð³',
              id: 'ÐÐ°ÑÐ²Ð»ÐµÐ½Ð¸Ðµ Ð¾ Ð¿Ð¾ÑÑÐ°Ð½Ð¾Ð²ÐºÐµ Ð¢Ð¡ Ð² Ð·Ð°Ð»Ð¾Ð³',
              component: DocsInputNew,
              required: true,
            },
            {
              text: 'Ð£Ð´Ð¾ÑÑÐ¾Ð²ÐµÑÐµÐ½Ð¸Ðµ Ð»Ð¸ÑÐ½Ð¾ÑÑÐ¸',
              label: 'ÐÐ°Ð³ÑÑÐ·Ð¸ÑÑ Ð´Ð¾ÐºÑÐ¼ÐµÐ½Ñ',
              name: 'Ð£Ð´Ð¾ÑÑÐ¾Ð²ÐµÑÐµÐ½Ð¸Ðµ Ð»Ð¸ÑÐ½Ð¾ÑÑÐ¸',
              id: 'Ð£Ð´Ð¾ÑÑÐ¾Ð²ÐµÑÐµÐ½Ð¸Ðµ Ð»Ð¸ÑÐ½Ð¾ÑÑÐ¸',
              component: DocsInputNew,
              required: true,
            },
            {
              text: 'Ð£Ð´Ð¾ÑÑÐ¾Ð²ÐµÑÐµÐ½Ð¸Ðµ Ð»Ð¸ÑÐ½Ð¾ÑÑÐ¸ ÑÑÐ¿ÑÑÐ³Ð°',
              label: 'ÐÐ°Ð³ÑÑÐ·Ð¸ÑÑ Ð´Ð¾ÐºÑÐ¼ÐµÐ½Ñ',
              name: 'Ð£Ð´Ð¾ÑÑÐ¾Ð²ÐµÑÐµÐ½Ð¸Ðµ Ð»Ð¸ÑÐ½Ð¾ÑÑÐ¸ ÑÑÐ¿ÑÑÐ³Ð°',
              id: 'Ð£Ð´Ð¾ÑÑÐ¾Ð²ÐµÑÐµÐ½Ð¸Ðµ Ð»Ð¸ÑÐ½Ð¾ÑÑÐ¸ ÑÑÐ¿ÑÑÐ³Ð°',
              component: DocsInputNew,
            },
            {
              text: 'Ð¡Ð¿ÑÐ°Ð²ÐºÐ° Ð¾Ð± Ð¾ÑÑÑÑÑÑÐ²Ð¸Ð¸ Ð½Ð°Ð»Ð¾Ð³Ð¾Ð²Ð¾Ð¹ Ð·Ð°Ð´Ð¾Ð»Ð¶ÐµÐ½Ð½Ð¾ÑÑÐ¸',
              label: 'ÐÐ°Ð³ÑÑÐ·Ð¸ÑÑ Ð´Ð¾ÐºÑÐ¼ÐµÐ½Ñ',
              name: 'Ð¡Ð¿ÑÐ°Ð²ÐºÐ° Ð¾Ð± Ð¾ÑÑÑÑÑÑÐ²Ð¸Ð¸ Ð½Ð°Ð»Ð¾Ð³Ð¾Ð²Ð¾Ð¹ Ð·Ð°Ð´Ð¾Ð»Ð¶ÐµÐ½Ð½Ð¾ÑÑÐ¸',
              id: 'Ð¡Ð¿ÑÐ°Ð²ÐºÐ° Ð¾Ð± Ð¾ÑÑÑÑÑÑÐ²Ð¸Ð¸ Ð½Ð°Ð»Ð¾Ð³Ð¾Ð²Ð¾Ð¹ Ð·Ð°Ð´Ð¾Ð»Ð¶ÐµÐ½Ð½Ð¾ÑÑÐ¸',
              component: DocsInputNew,
              required: true,
            },
            {
              text: 'ÐÐ°ÑÐ²Ð»ÐµÐ½Ð¸Ðµ Ð¾ Ð²ÐºÐ»ÑÑÐµÐ½Ð¸Ð¸ ÑÑÑÐ°ÑÐ¾Ð²Ð¾Ð¹ Ð¿ÑÐµÐ¼Ð¸Ð¸ Ð¸ ÑÑÐ¾Ð¸Ð¼Ð¾ÑÑÐ¸ Ð´Ð¾Ð¿.Ð¾Ð±Ð¾ÑÑÐ´Ð¾Ð²Ð°Ð½Ð¸Ñ Ð² ÑÑÐ¼Ð¼Ñ Ð±Ð°Ð½ÐºÐ¾Ð²ÑÐºÐ¾Ð³Ð¾ Ð·Ð°Ð¹Ð¼Ð°',
              label: 'ÐÐ°Ð³ÑÑÐ·Ð¸ÑÑ Ð´Ð¾ÐºÑÐ¼ÐµÐ½Ñ',
              name: 'ÐÐ°ÑÐ²Ð»ÐµÐ½Ð¸Ðµ Ð¾ Ð²ÐºÐ»ÑÑÐµÐ½Ð¸Ð¸',
              id: 'ÐÐ°ÑÐ²Ð»ÐµÐ½Ð¸Ðµ Ð¾ Ð²ÐºÐ»ÑÑÐµÐ½Ð¸Ð¸',
              component: DocsInputNew,
              required: true,
            },
          ]}
          onSubmit={onRegistarationDocumentsFormSubmit}
          loading={loading}
          backHandler={backHandler}
        />
      </div>
    );
  }

  return (
    <div>
      <HookForm
        title={'ÐÐ¾ÐºÑÐ¼ÐµÐ½ÑÑ'}
        grid={{ display: 'grid', gap: 20 }}
        action={'Ð¡Ð¾ÑÑÐ°Ð½Ð¸ÑÑ Ð¸ Ð¿ÑÐ¾Ð´Ð¾Ð»Ð¶Ð¸ÑÑ'}
        inputs={[]}
        customDataTop={() => (
          <div style={{ marginBottom: 40 }}>
            {documents
              ?.filter(
                (item) =>
                  item?.typeId === DOCUMENT_TYPES_PLEDGE_AGREEMENT ||
                  item?.typeId === DOCUMENT_TYPES_PLEDGE_APPLICATION ||
                  item?.typeId === DOCUMENT_TYPES_UDV ||
                  item?.typeId === DOCUMENT_TYPES_NO_TAX_DEBT ||
                  item?.typeId === DOCUMENT_TYPES_APPLICATION_PREMIUM_AND_ADDITIONAL_EQUIPMENT_LOAN
              )
              .map((document) => (
                <DownloadFileLink document={document} />
              ))}
          </div>
        )}
        onSubmit={skipStep}
        loading={loading}
        backHandler={backHandler}
      />
    </div>
  );
};

export default DealCreateCreditDocuments;
